export const normalizeEmail = (email) => email?.trim().toLowerCase() || null;

export const isValidEmail = (email) => {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(normalized);
};

export const normalizeBelgianPhone = (phone) => {
  if (!phone) return null;

  let value = String(phone).trim();
  value = value.replace(/[-\s.()]/g, "");

  if (value.startsWith("0032")) {
    value = `+32${value.slice(4)}`;
  }

  if (value.startsWith("0")) {
    value = `+32${value.slice(1)}`;
  }

  return value || null;
};

export const isValidBelgianPhone = (phone) => {
  const normalized = normalizeBelgianPhone(phone);
  if (!normalized) return false;

  if (!/^\+32\d{8,9}$/.test(normalized)) return false;

  const nationalPart = normalized.replace("+32", "");
  return !/^0+$/.test(nationalPart);
};

export const normalizeBelgianVat = (vat) => {
  if (!vat) return null;

  let value = String(vat).trim().toUpperCase();
  value = value.replace(/[\s.-]/g, "");

  if (value.startsWith("BE")) {
    value = value.slice(2);
  }

  if (!/^\d{10}$/.test(value)) return null;
  if (/^0+$/.test(value)) return null;

  return `BE${value}`;
};

export const isValidBelgianVat = (vat) => Boolean(normalizeBelgianVat(vat));

export const contactErrors = (phone, email) => ({
  phone: phone && !isValidBelgianPhone(phone) ? "Geef een geldig Belgisch telefoonnummer in." : "",
  email: email && !isValidEmail(email) ? "Geef een geldig e-mailadres in." : ""
});

export const vatError = (vatNumber) => (
  vatNumber && !isValidBelgianVat(vatNumber) ? "Geef een geldig Belgisch BTW-nummer in." : ""
);
